import { Toaster } from '@massilia/ui'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { createRootRouteWithContext, Link, Outlet } from '@tanstack/react-router'
import { SearchX } from 'lucide-react'
import { lazy, Suspense } from 'react'

import { ChatWidget } from '@/components/chat/chat-widget'

const TanStackRouterDevtools =
  process.env.NODE_ENV === 'production'
    ? () => null
    : lazy(() =>
        import('@tanstack/router-devtools').then((res) => ({
          default: res.TanStackRouterDevtools,
        }))
      )

const isChatWidgetEnabled = import.meta.env.VITE_ENABLE_CHAT_WIDGET === 'true'

export const Route = createRootRouteWithContext()({
  component: () => (
    <div className="bg-gray-25 flex min-h-screen min-w-screen flex-col items-center">
      <App />
      <Suspense>
        <TanStackRouterDevtools />
      </Suspense>
    </div>
  ),
  notFoundComponent: () => (
    <div className="flex flex-1 items-center justify-center">
      <div className="flex max-w-md flex-col items-center gap-6 text-center">
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-amber-100">
          <SearchX className="h-8 w-8 text-amber-600" />
        </div>
        <div className="space-y-2">
          <h1 className="text-2xl font-semibold text-stone-800">Page introuvable</h1>
          <p className="text-stone-600">
            La page que vous recherchez n&apos;existe pas ou a été déplacée.
          </p>
        </div>
        <Link
          to="/research-bar"
          className="inline-flex items-center gap-2 rounded-lg bg-[#1D95AD] px-6 py-3 font-medium text-white transition-colors hover:bg-[#1a8599]"
        >
          Retour à l&apos;accueil
        </Link>
      </div>
    </div>
  ),
})

function App() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnMount: true,
        refetchOnReconnect: false,
        refetchOnWindowFocus: false,
        retry: false,
        staleTime: 5 * 1000 * 60, //5 minutes
      },
    },
  })

  return (
    <QueryClientProvider client={queryClient}>
      <Outlet />
      {isChatWidgetEnabled ? <ChatWidget /> : null}
      <Toaster position="top-right" richColors theme="system" />
    </QueryClientProvider>
  )
}
